function BallooninBundle() {
    var app = this;

    this.init = function() {
        app.initEvents();
        app.initCarousels();
        window.dispatchEvent(new Event('resize'));
    };

    this.initEvents = function() {
        $(window).on('resize', function() {
            _.debounce(app.resize(), 100);
        });
    };

    this.initCarousels = function () {
        $.each($('.options-list.frontend-slider'),function (index,el) {
            if($(el).find('> div').length > 4) {
                $(el).slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    infinite: false,
                    adaptiveHeight: true,
                    responsive: [
                        {
                            breakpoint: 599,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
            }
        });
    }

    this.resize = function () {

    }
}
let ballooninBundle = new BallooninBundle();
ballooninBundle.init();
